// cart-notification.js — StateDecal
// <cart-notification> Web Component: slide-in toast after add-to-cart

class CartNotification extends HTMLElement {
  connectedCallback() {
    document.addEventListener('cart:item-added', this.show.bind(this));
  }

  show(e) {
    var detail = e.detail || {};
    var title = detail.title || 'Added to cart';
    var price = detail.price || '';

    // Remove any existing toast first
    var existing = document.querySelector('.cart-toast');
    if (existing) {
      existing.remove();
    }

    var toast = document.createElement('div');
    toast.className = 'cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    toast.innerHTML =
      '<div class="cart-toast__icon">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
      '</div>' +
      '<div class="cart-toast__body">' +
        '<p class="cart-toast__title">' + CartNotification.escapeHtml(title) + '</p>' +
        (price ? '<p class="cart-toast__price">' + CartNotification.escapeHtml(price) + '</p>' : '') +
      '</div>' +
      '<a href="/cart" class="cart-toast__cta">View Cart</a>' +
      '<button class="cart-toast__close" aria-label="Dismiss notification">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
      '</button>';

    document.body.appendChild(toast);

    // Trigger entrance animation on next frame
    requestAnimationFrame(function () {
      toast.classList.add('cart-toast--visible');
    });

    // Auto-dismiss after 4 seconds
    var timer = setTimeout(function () {
      CartNotification.dismiss(toast);
    }, 4000);

    toast.querySelector('.cart-toast__close').addEventListener('click', function () {
      clearTimeout(timer);
      CartNotification.dismiss(toast);
    });
  }

  static dismiss(toast) {
    toast.classList.remove('cart-toast--visible');
    toast.classList.add('cart-toast--exiting');
    setTimeout(function () {
      if (toast.parentNode) toast.remove();
    }, 400);
  }

  static escapeHtml(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }
}

customElements.define('cart-notification', CartNotification);
